<template>
  <div>
    <layout-sub-modulo>
      <template v-slot:title> Parametrización de convenio </template>
      <template v-slot:body>
        <v-container class="px-12 w-full">
          <v-form ref="formularioRef" :lazy-validation="true">
            <v-card-title>Convenio</v-card-title>
            <v-card-subtitle class="pb-1 grey--text text--darken-1 font-italic">
              Configure los parámetros necesarios para la administración de la
              gestión de créditos.
            </v-card-subtitle>
            <v-divider class="pb-5"></v-divider>

            <v-row class="d-flex mx-1">
              <v-col cols="3">
                <v-text-field
                  v-model="idSiesa"
                  label="Codigo Siesa *"
                  outlined
                  dense
                  :rules="[validacion.required, validacion.numerico]"
                />
              </v-col>
            </v-row>
            <table-sucursales-convenio
              :listadoSucursalesConvenio="listadoSucursalesConvenio"
              @editar-convenio="editarSucursalConvenio"
            >
            </table-sucursales-convenio>

            <div class="d-flex justify-center">
              <router-link :to="{ name: 'parametrizacionempresa' }">
                <v-btn class="mt-4 white--text" color="error"> Cancelar </v-btn>
              </router-link>
              <v-btn
                class="mt-4 ml-4 white--text"
                color="primary"
                :loading="listadoSucursalesConvenio.loading"
                @click="actualizarConvenio"
              >
                Actualizar
              </v-btn>
            </div>
          </v-form>
        </v-container>
      </template>
    </layout-sub-modulo>

    <modal-editar-sucursal
      :sucursales="sucursales"
      :nit="nit"
      ref="refModalEditarSucursal"
      @cerrar-modal="cerrarModalSucursal"
      @listar-sucursales="listarSucursalesConvenio"
    >
    </modal-editar-sucursal>
  </div>
</template>

<script>
import TableSucursalesConvenio from './Table/SucursalesConvenioTable.vue';
import LayoutSubModulo from '../../../components/Layout/SubModulo.vue';
import ModalEditarSucursal from './Modal/EditarSucursal.vue';
import empresaService from '../../../Services/empresaService';

export default {
  name: 'ParametrizarConvenio',

  components: {
    TableSucursalesConvenio,
    LayoutSubModulo,
    ModalEditarSucursal,
  },

  data() {
    return {
      estaEditando: false,
      idSiesa: Number,
      sucursales: [],
      nit: this.$route.params.nit.toString(),
      mostrarValidaciones: false,
      listadoSucursalesConvenio: {
        data: [],
        loading: false,
      },
      validacion: {
        required: value =>
          this.mostrarValidaciones
            ? !!value || 'Este campo es obligatorio'
            : true,
        numerico: value => {
          if (!this.mostrarValidaciones) return true;
          const pattern = /^[1-9]+$/;
          return (
            pattern.test(value) ||
            'El campo recibe solo valores numéricos positivos.'
          );
        },
      },
    };
  },

  created() {
    this.listarSucursalesConvenio();
  },

  methods: {
    cerrarModalSucursal() {
      this.$refs.refModalEditarSucursal.cerrarModal();
    },

    async listarSucursalesConvenio() {
      this.listadoSucursalesConvenio.loading = true;
      this.listadoSucursalesConvenio.data = [];
      const filtro = { tieneConvenio: true, nit: this.nit };
      const convenioPorNit = await empresaService.buscarTodos(filtro);
      const response = convenioPorNit.data?.[0] || null;
      if (!response) {
        this.listadoSucursalesConvenio.loading = false;
        return;
      }

      this.sucursales = response.sucursales;
      this.idSiesa = response.compania_id;
      this.listadoSucursalesConvenio.data = response.sucursales;
      this.listadoSucursalesConvenio.loading = false;
    },

    async actualizarConvenio() {
      this.mostrarValidaciones = true;
      this.$nextTick(() => {
        if (!this.$refs.formularioRef.validate()) {
          return;
        }

        this.listadoSucursalesConvenio.loading = true;

        const datosConvenio = {
          compania_id: Number.parseInt(this.idSiesa),
        };

        empresaService
          .actualizarPorNit(this.nit, datosConvenio)
          .then(() => {
            this.listadoSucursalesConvenio.loading = false;
            this.$router.push({ name: 'parametrizacionempresa' });
          })
          .catch(() => {
            this.listadoSucursalesConvenio.loading = false;
          });
      });
    },

    editarSucursalConvenio(item) {
      const index = this.listadoSucursalesConvenio.data.findIndex(
        s => s.sucursal_id === item.sucursal_id
      );
      this.$refs.refModalEditarSucursal.editarItem(item, index);
      this.$refs.refModalEditarSucursal.abrirModal();
    },
  },
};
</script>
